import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import SingleSelect, {
  SingleSelectOption
} from "@/components/controls/SingleSelect";
import { getCurrentLocale } from "@/utils/locale";
import { getLocalizedCountryOptions } from "@/utils/countries";
import { HALF_WRAPPER_CLASSNAME } from "../shared";
import { asString, ControlProps } from "../types";

const getCountryOptions = (locale: string): SingleSelectOption[] =>
  getLocalizedCountryOptions(locale).map(({ code, label }) => ({
    id: code,
    displayName: label
  }));

export const CountryControl: React.FC<ControlProps> = ({
  value,
  onChange,
  name,
  config,
  singleSelect
}) => {
  const { t } = useTranslation();
  const locale = getCurrentLocale();
  const options = useMemo(() => getCountryOptions(locale), [locale]);

  return (
    <div className={HALF_WRAPPER_CLASSNAME}>
      <SingleSelect
        fieldName={name}
        options={options}
        selectedValue={asString(value) || undefined}
        onSelection={(selected) => onChange(String(selected))}
        placeholder={config?.placeholder ?? t("select")}
        showSearch
        clearable
        onClear={() => onChange(undefined)}
        variant={singleSelect?.variant}
        sideOffset={singleSelect?.sideOffset}
      />
    </div>
  );
};
